<template>
  <div class="shsj-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :rules="rules" :model="searchForm">
            <el-form-item label="选择月份">
              <el-date-picker
                v-model="searchForm.time"
                type="month"
                format="yyyy年MM月"
                value-format="yyyy-MM"
                placeholder="选择月份">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button :loading="btnLoading" icon="el-icon-s-data" @click="getData">统计</el-button>
            </el-form-item>
            <el-form-item>
              <el-button :loading="btnLoading" icon="el-icon-printer" @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row v-loading="btnLoading">
              <el-col :span="24">
                <table class="tcf-bb-table">
                    <tr>
                      <th>日期</th>
                      <th>专卖店</th>
                      <th>客户地址</th>
                      <th>生产单号</th>
                      <th>承担金额（元）</th>
                      <th>车间</th>
                      <th>责任部门</th>
                      <th>不良类别</th>
                      <th>客诉内容</th>
                      <th>设计师</th>
                      <th>补单号</th>
                      <th>正单金额</th>
                      <th>系统单号</th>
                    </tr>
                    <tr v-for="item in orderDeliveryDetailList">
                      <td>{{item.date}}</td>
                      <td>{{item.shop}}</td>
                      <td>{{item.address}}</td>
                      <td>{{item.productNum}}</td>
                      <td>{{item.nullStr}}</td>
                      <td>{{item.factory}}</td>
                      <td>{{item.deptName}}</td>
                      <td>{{item.nullStr}}</td>
                      <td>{{item.nullStr}}</td>
                      <td>{{item.designer}}</td>
                      <td>{{item.nullStr}}</td>
                      <td>{{item.orderAmount}}</td>
                      <td>{{item.orderNum}}</td>
                    </tr>
                </table>
              </el-col>
              <el-col :span="12">
                <table class="tcf-bb-table">
                    <tr>
                      <th colspan="6" width="637">
                        {{orderDeliveryDetailMap.month}}月份售后占比分析
                      </th>
                    </tr>
                    <tr>
                      <th>
                        序号
                      </th>
                      <th>
                        车间
                      </th>
                      <th>
                        售后费用
                      </th>
                      <th width="120">
                        出错订单金额
                      </th>
                      <th width="124">
                        售后不良率
                      </th>
                      <th>
                        各车间比重
                      </th>
                    </tr>
                    <tr>
                      <td>
                        1
                      </td>
                      <td>
                        1车间
                      </td>
                      <td>
                        {{orderDeliveryDetailMap.oneAfter}}
                      </td>
                      <td>
                        {{orderDeliveryDetailMap.onePrice}}
                      </td>
                      <td>
                        {{(orderDeliveryDetailMap.oneNoGoodRate*100).toFixed(2)}}%
                      </td>
                      <td>
                        {{(orderDeliveryDetailMap.oneRate*100).toFixed(2)}}%
                      </td>
                    </tr>
                    <tr>
                      <td>
                        2
                      </td>
                      <td>
                        3车间
                      </td>
                      <td>
                        {{orderDeliveryDetailMap.threeAfter}}
                      </td>
                      <td>
                        {{orderDeliveryDetailMap.threePrice}}
                      </td>
                      <td>
                        {{(orderDeliveryDetailMap.threeNoGoodRate*100).toFixed(2)}}%
                      </td>
                      <td>
                        {{(orderDeliveryDetailMap.threeRate*100).toFixed(2)}}%
                      </td>
                    </tr>
                    <tr>
                      <td>
                        3
                      </td>
                      <td>
                        7车间
                      </td>
                      <td>
                        {{orderDeliveryDetailMap.sevenAfter}}
                      </td>
                      <td>
                        {{orderDeliveryDetailMap.sevenPrice}}
                      </td>
                      <td>
                        {{(orderDeliveryDetailMap.sevenNoGoodRate*100).toFixed(2)}}%
                      </td>
                      <td>
                        {{(orderDeliveryDetailMap.sevenRate*100).toFixed(2)}}%
                      </td>
                    </tr>
                    <tr>
                      <td>
                        4
                      </td>
                      <td>
                        8车间
                      </td>
                      <td>
                        {{orderDeliveryDetailMap.eightAfter}}
                      </td>
                      <td>
                        {{orderDeliveryDetailMap.eightPrice}}
                      </td>
                      <td>
                        {{(orderDeliveryDetailMap.eightNoGoodRate*100).toFixed(2)}}%
                      </td>
                      <td>
                        {{(orderDeliveryDetailMap.eightRate*100).toFixed(2)}}%
                      </td>
                    </tr>
                    <tr>
                      <td>
                        5
                      </td>
                      <td>
                        设计
                      </td>
                      <td>
                        {{orderDeliveryDetailMap.designAfter}}
                      </td>
                      <td>
                        {{orderDeliveryDetailMap.designPrice}}
                      </td>
                      <td>
                        {{(orderDeliveryDetailMap.designNoGoodRate*100).toFixed(2)}}%
                      </td>
                      <td>
                        {{(orderDeliveryDetailMap.designRate*100).toFixed(2)}}%
                      </td>
                    </tr>
                    <tr>
                      <td>
                        6
                      </td>
                      <td>
                        合计
                      </td>
                      <td>
                        {{orderDeliveryDetailMap.totalAfter}}
                      </td>
                      <td>
                        {{orderDeliveryDetailMap.totalPrice}}
                      </td>
                      <td></td>
                      <td>
                        100.00%
                      </td>
                    </tr>
                </table>
              </el-col>
              <el-col :span="11" :offset="1">
                <table class="tcf-bb-table">
                    <tr>
                      <th width="95">
                        类别
                      </th>
                      <th width="100">
                        金额
                      </th>
                      <th width="96">
                        类别
                      </th>
                      <th width="120">
                        金额
                      </th>
                      <th width="124">
                        设计
                      </th>
                      <th width="103"></th>
                    </tr>
                    <tr>
                      <td width="95">
                        木工
                      </td>
                      <td width="100">
                        {{orderDeliveryDetailMap.woodPrice}}
                      </td>
                      <td width="96">
                        1车间
                      </td>
                      <td width="120">
                        {{orderDeliveryDetailMap.oneAfter}}
                      </td>
                      <td width="124">
                        {{orderDeliveryDetailMap.oneDesignPrice}}
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td width="95">
                        油漆
                      </td>
                      <td width="100">
                        {{orderDeliveryDetailMap.paintPrice}}
                      </td>
                      <td width="96">
                        3车间
                      </td>
                      <td width="120">
                        {{orderDeliveryDetailMap.threeAfter}}
                      </td>
                      <td width="124">
                        {{orderDeliveryDetailMap.threeDesignPrice}}
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td width="95">
                        设计
                      </td>
                      <td width="100">
                        {{orderDeliveryDetailMap.designMulPrice}}
                      </td>
                      <td width="96">
                        7车间
                      </td>
                      <td width="120">
                        {{orderDeliveryDetailMap.sevenAfter}}
                      </td>
                      <td width="124">
                        {{orderDeliveryDetailMap.sevenDesignPrice}}
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td width="95">
                        物流
                      </td>
                      <td width="100">
                        {{orderDeliveryDetailMap.wuliuPrice}}
                      </td>
                      <td width="96">
                        8车间
                      </td>
                      <td width="120">
                        {{orderDeliveryDetailMap.eightAfter}}
                      </td>
                      <td width="124">
                        {{orderDeliveryDetailMap.eightDesignPrice}}
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td width="95">
                        外协
                      </td>
                      <td width="100">
                        {{orderDeliveryDetailMap.outPrice}}
                      </td>
                      <td width="96">
                        设计部
                      </td>
                      <td width="120">
                        {{orderDeliveryDetailMap.designMulPrice}}
                      </td>
                      <td width="124">
                        设计漏下金额
                      </td>
                      <td width="103">
                        {{orderDeliveryDetailMap.louxiaPrice}}
                      </td>
                    </tr>
                </table>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getMonthFactoryData } from '@/api/tj'
import { dateFormat } from '@/utils/index'

export default {
  name: 'shsj',
  data() {
    return {
      tableData: [],
      searchForm: {
        time: ''
      },
      rules: {
        time: [{ required: true, message: '请选择月份', trigger: 'change' }]
      },
      btnLoading: false,
      orderDeliveryDetailMap: {},
      orderDeliveryDetailList: [],
      addOrderDeliveryDetail: {}
    }
  },
  computed: {
    user: getUser
  },
  created() {
    const end = new Date()
    const endTime = dateFormat('YYYY-mm', end)
    this.searchForm.time = endTime
    this.getData()
  },
  methods: {
    changeMark(val) {
      this.mark = val
      this.getData()
    },
    getData() {
      const data = {
        month: this.searchForm.time,
        type: 0,
        userid: this.user.dUserid
      }
      this.btnLoading = true
      getMonthFactoryData(data).then(response => {
        this.orderDeliveryDetailList = response.data.list
        this.orderDeliveryDetailMap = response.data.map
        this.btnLoading = false
      }).catch(() => {
        this.btnLoading = false
      })
    },
    exportExcel() {
      const data = {
        month: this.searchForm.time,
        type: 1,
        userid: this.user.dUserid
      }
      this.btnLoading = true
      let file = null
      getMonthFactoryData(data).then(response => {
        file = response.data
        this.downLoad(file)
        this.btnLoading = false
      }).catch(() => {
        this.btnLoading = false
      })
    },
    downLoad(file) {
      const _this = this
      let xhr = new XMLHttpRequest()
      xhr.open('GET', file.dPath, true)
      xhr.responseType = 'blob'
      xhr.onload = function() {
        if (this.status === 200) {
          let blob = this.response
          let a = document.createElement('a')
          a.download = file.dName
          a.href = window.URL.createObjectURL(blob)
          a.target = '_blank'
          a.click()
          _this.excelLoading = false
          const h = _this.$createElement
          _this.$msgbox({
            title: '下载提示',
            message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
              h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
              h('a',
                { attrs: {
                  href: window.URL.createObjectURL(blob),
                  target: '_blank',
                  download: `${file.dName}`,
                  style: 'color: #409EFF;text-decoration:underline;'
                }}, `点击这里`),
              h('span', null, `重新下载。`)
            ]),
            showCancelButton: false,
            confirmButtonText: '关闭',
            beforeClose: (action, instance, done) => {
              done()
            }
          }).then(action => {
          })
        }
      }
      xhr.send()
    }
  }

}
</script>

<style lang="scss" scoped>
  .tcf-bb-table{
    width: 100%;
    background-color: #fff;
    border-collapse: collapse;
    border-spacing: 0;
    font-size: 13px;
    text-align: center;
    margin-top: 20px;
    tr{
      th{
        border: 1px solid #EBEEF5;
        background: #f6f8fa;
        color: #303133;
        padding: 12px 0;
      }
      td{
        border: 1px solid #EBEEF5;
        color: #303133;
        padding: 12px 0;
      }
      &:hover{
        background: #f3f6f9;
      }
    }
  }
</style>
